export default __webpack_public_path__ + "static/media/client7.f3a3eba0.jpg";